export const DeleteButtonTooltipContent: React.FC<{
	hasUsers: boolean;
	hasSubscriptions: boolean;
}> = ({ hasUsers, hasSubscriptions }) => {
	if (hasUsers && hasSubscriptions)
		return (
			<>
				Company cannot be deleted because it has users and
				subscriptions. To delete the company, reassign all users and
				remove all subscriptions first.
			</>
		);

	if (hasUsers)
		return (
			<>
				Company cannot be deleted because it has users. To delete the
				company, reassign all users first.
			</>
		);

	return (
		<>
			Company cannot be deleted because it has subscriptions. To delete
			the company, remove all subscriptions first.
		</>
	);
};
